export default __webpack_public_path__ + "static/media/SurfaceLaptop.14dcacb9.svg";